import React from "react";
import { useSelector } from "react-redux";
import ProductCards from "../components/ProductCards/index";
import Load from "../components/Loading/index";

export default function ProductSearch() {
    const { SearchKey, Search, Loading } = useSelector(
        (state) => state.product
    );

    return (
        <>
            {!Loading ? (
                <>
                    <ProductCards text={`Search for ${SearchKey}`} product={Search}></ProductCards>
                </>
            ) : (
                <Load text={"Loading Products"} />
            )}
        </>
    );
}
